import { ref } from 'vue';

const posthog = ref(null);

/**
 * @param {string} eventName
 * @param {import('posthog-js').Properties} [properties]
 * @returns {void}
 */
const capturePosthogEvent = (eventName, properties = {}) => {
    if (posthog.value) {
        posthog.value.capture(eventName, properties);
    }
};

const usePosthog = () => ({
    posthog,
});

export { capturePosthogEvent, usePosthog };
